module.exports = __webpack_public_path__ + "mus-logo_120.png?db0c3eaa0bc723915e88e38e0efb4072";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mus-logo_120.png
// module id = 41
// module chunks = 0